import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import * as ReactRedux from 'react-redux'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {CSSProperties} from 'react'
import {CampusArtEdit} from '../ProofEdit/CampusArtEdit'
import {CampusProductEdit} from '../ProofEdit/CampusProductEdit'
import {WebstoreInfo} from '../ProofEdit/WebstoreInfo'
import {NewCampusUploadFiles} from '../UploadFiles/NewCampusUploadFiles'
import {ScreenDoor} from '../Components/ScreenDoor'
import {CampusTextEdit} from '../ProofEdit/CampusTextEdit'
import {CampusNotesEdit} from '../ProofEdit/CampusNotesEdit'
import {Message} from '../Components/Message'
import {CampusFooter} from '../Components/CampusFooter'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'
import {CampusHeader} from '../Components/CampusHeader';
import {CampusFeedback} from '../FlatPages/CampusFeedback';
import { CatalogArtUpload } from '../UploadFiles/CatalogArtUpload'

const proofEditStyle : CSSProperties = {
    position: 'relative',
    height:'auto',
    width:'100%',
}
const editZoneStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin:'auto'
}
let submitBtnStyle : CSSProperties = {
    backgroundColor:'#E27558',
    color:'white',
    width:'529px',
    height:'49px',
    margin:'15px auto',
    textAlign:'center',
    lineHeight:'3.2em',
    fontFamily:'Lulo',
    cursor:'pointer',
    border:'1px solid transparent',
    ':hover': {
        backgroundColor:'white',
        color:'#E27558',
        border:'1px solid grey'
    }
}

const hdrDiv: CSSProperties = {
    textAlign:'center',
    fontFamily:'BarlowMedium',
    marginTop:'15px'
}

const lines:React.CSSProperties = {
    width:'980px',
    borderBottom:'1px solid #EEEDED',
    margin:'15px auto'
}
const lineCont: React.CSSProperties = {
    margin:'110px'
}

const hrdText: React.CSSProperties = {
    color:'rgba(66, 66, 66, 0.8)',
    fontSize:'25px',
    textTransform:'uppercase',
    letterSpacing:'1px'
}

const inputStyle : CSSProperties = {
    fontFamily: 'BarlowLight',
    fontSize: '16px',
    margin: '10px auto',
    border: '1px solid #A7A7A7',
    boderSpacing: 0,
    height: '300px',
    width: '500px',
    resize: 'none',
    overflowY: 'hide',
    overflowX: 'auto'
}
let emptyNotesStyle = Object.assign({},inputStyle,{color: 'black'});

let errorStyle=Object.assign({}, Tgcc.Styles.error, {fontSize:'20px', marginBottom: '5px'});
const space: CSSProperties = {
    height:'35px'
}
class StateType {
    password: string;
    confirmPassword: string;
    error: string;
    isWaiting: boolean;
    proofId: string;
    uploadedFiles: any;
    finished: boolean;
    Notes:string;
}

const  isBlankOrEmpty = (str: string) => {
    if(!str)
        return true;
    if(!str.trim())
        return true;
    return false;
}


class _Webstore extends React.Component<Tgcc.BaseProps, any>{

    state: StateType = new StateType();

    componentWillMount(){
        this.state.uploadedFiles = [];
        if(!this.props.state.ActiveProof){
            var newProof = new Tgcc.Proof();
            newProof.phone = this.props.state.UserInfo.phone;
            newProof.smsAllowed = this.props.state.UserInfo.smsAllowed;
            this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: newProof});
        }

    }
    componentDidMount(){
        var tag = document.getElementById('proof');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    setError = (msg: string) => {
        this.setState({error: msg, isWaiting: false}, () => {
            this.scrollPageToView("TopProofError");
        });
        return false;
    }

    validatePasswords = () => {
        if(!this.state.password || !this.state.password.trim())
            return this.setError('Password cannot be blank');
        if(!this.state.confirmPassword)
            return this.setError('Passwords do not match');
        if(this.state.password.trim() != this.state.confirmPassword.trim())
            return this.setError('Passwords do not match');
        return true;
    }

    allDone = () => {

    }

    registerNewUser = ( onSuccess: (login: Tgcc.LoginData, user: Tgcc.UserInfo) => void) => {
        var user = this.props.state.UserInfo;
        if(!user.firstName || !user.firstName.trim())
            this.setError('First Name cannot be blank');
        else if(!user.lastName || !user.lastName.trim())
            this.setError('Last Name cannot be blank');
        else if(!user.email || !user.email.trim())
            this.setError('Email cannot be blank');
        else if(!this.state.password || !this.state.password.trim())
            this.setError('Password cannot be blank');
        else if(this.state.password != this.state.confirmPassword)
            this.setError('Passwords do not match');
        else {
            this.setState({isWaiting: true});
            Request.registerUser(user, this.state.password, this.state.confirmPassword,
                (newUser: Tgcc.UserInfo) => {
                    Request.loginUser(user.email, this.state.password,
                        (ld: Tgcc.LoginData) => {
                            this.props.dispatch({type: Tgcc.StateAction.Login, payload: ld}); 
                            this.props.dispatch({type: Tgcc.StateAction.SetUserInfo, payload: user}); 
                            onSuccess(ld, user);
                        },
                        (err: string) => {})
                },
                this.setError);
        }
    }

    saveWebstoreRequest = (loginData: Tgcc.LoginData, proof: Tgcc.Proof) => {
        var email = loginData.username;
        this.setState({isWaiting: true});
        var setDate = new Date(proof.inHandsDate)
        setDate.setHours(setDate.getHours() +4)
        proof.inHandsDate = this.formatinHandsDate(setDate)
        Request.createWebstoreRequest(email, loginData, proof, this.proofComplete, (err) =>{
            this.setError(err);
        });
    }

    proofComplete = (proof: Tgcc.Proof) => {
        this.setState({finished: true, proofId: proof.proofId});
    }

    updateUserInfo = (user: Tgcc.UserInfo) => {
        Request.updateUser(this.props.state.LoginData, user, 
            (userData: Tgcc.UserInfo) => {
                this.props.dispatch({type: Tgcc.StateAction.SetUserInfo, payload: userData});
            },
            () => {}
        );
    }

    successfulRegistration = (login: Tgcc.LoginData,  uData: Tgcc.UserInfo) => {
        Tgcc.successfulLogin(this.props.dispatch, login)
        this.updateUserInfo(uData)
        this.saveWebstoreRequest(login, this.props.state.ActiveProof);
    }

    formatDate = (date:Date,days:number) => {
        var monthNames = [
            "01", "02", "03",
            "04", "05", "06", "07",
            "08", "09", "10",
            "11", "12"
        ];
        var day = date.getDate() + days;
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        var today = year + '-' + monthNames[monthIndex] + '-' + day;

        return today;
}

formatinHandsDate = (date:Date) => {
    var monthNames = [
        "01", "02", "03",
        "04", "05", "06", "07",
        "08", "09", "10",
        "11", "12"
    ];

    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var today = year + '-' + monthNames[monthIndex] + '-' + day;

    return today;
}

    validateUser = () => {
        if(!this.props.state.UserInfo)
            return this.setError("Please login or register");

        var user = this.props.state.UserInfo;
        
        // Check if CSR is impersonating - if so, bypass profile requirements
        const isImpersonating = this.props.state.LoginData && this.props.state.LoginData.impersonate;
        
        if(isImpersonating) {
            // Only validate email for impersonated users
            if(isBlankOrEmpty(user.email))
                return this.setError("Email address cannot be null");
            if(!Tgcc.IsValidEmail(user.email))
                return this.setError("Email is not valid");
            return true;
        }
        
        // Full validation for regular users
        if(isBlankOrEmpty(user.email||user.firstName||user.lastName||user.email||user.phone))
            return this.setError("Please login or register");
        if(isBlankOrEmpty(user.email))
            return this.setError("Email address cannot be null");
        if(!Tgcc.IsValidEmail(user.email))
            return this.setError("Email is not valid");
        if(isBlankOrEmpty(user.firstName) || isBlankOrEmpty(user.lastName))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your first name and last name.");
        if(isBlankOrEmpty(user.phone))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your phone number.");
        if(isBlankOrEmpty(user.address))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your address.");
        if(isBlankOrEmpty(user.city))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your city.");
        if(isBlankOrEmpty(user.state))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your state.");
        if(isBlankOrEmpty(user.zip))
            return this.setError("Please complete your profile information. Go to your Dashboard to update your zip code.");
        if(!Tgcc.IsValidPhoneNumber(user.phone))
            return this.setError("Please enter a valid phone number. Go to your Dashboard to update your phone number.");
        return true;
    }
    validateDate = () => {
        if(isBlankOrEmpty(this.props.state.ActiveProof.inHandsDate)){
            return this.setError("In Hands Date cannot be blank")
        }
        return true;
    }

    submitProofRequest = () => {
        this.setState({error: null, isWaiting: true});

        if(!this.props.state.UserInfo){
            return this.setError("Please log in or register");
        }
        if(!this.validateDate())
            return

        if(!this.validateUser())
            return;
            
        if(!this.props.state.LoginData){
            if(!this.validatePasswords())
                return;
            this.registerNewUser( this.successfulRegistration );
        } else {
            var ld = this.props.state.LoginData;
            var proof = this.props.state.ActiveProof;
            this.updateUserInfo(this.props.state.UserInfo);
            this.saveWebstoreRequest(ld, proof);
        }
    }
    whenFinished = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof})
        window.location.reload();
    }
    editStart = (evt: React.SyntheticEvent<HTMLTextAreaElement>) =>{
        this.noteChanged(evt);
    }
    noteChanged = (evt: React.SyntheticEvent<HTMLTextAreaElement>) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateProofNotes, payload: evt.currentTarget.value});
    }

    getThankYou = () => {
        return <Message 
            Title="Thank You!"         
            UseTitleScript={true}
            Message1="Your webstore request has been received."
            Message2={"Proof Number: " + this.state.proofId}
            onContinue={this.whenFinished}
        />
    }
    getHrzLines() {
        return (
            <div style={lineCont}>
                <div style={lines}></div>
            </div>
        )
    }
    render() {
        var submitBtn = this.state.isWaiting ? Tgcc.workingGif : <div style={submitBtnStyle} onClick={this.submitProofRequest} className="campusSubmit">Submit Request</div>
        var thankYou = this.state.finished ? this.getThankYou() : null;
        var notes = this.state.Notes || '';
        var textEdit = notes ? 
                    <textarea name="existingNotes"
                        className="hoverBorder"
                        style={inputStyle}
                        value={notes}
                        onChange={this.noteChanged}>
                    </textarea>
                    :
                    <textarea
                        name="emptyNotes"
                        className="hoverBorder"
                        style={emptyNotesStyle}
                        onChange={this.editStart}
                        placeholder="Please provide all details to create a webstore"></textarea>
        return (
            <div style={proofEditStyle}>
            <div id="proof"></div>
            <CampusHeader />
            <WebstoreInfo />
                <div style={editZoneStyle} className='campusEditZone'>
                    {textEdit}
                </div>
                <div id="TopProofError" style={errorStyle}>{this.state.error}</div>               
                {submitBtn}
                {thankYou}
                <div style={space}></div>
            </div>
        );
    }   
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return { state: state};
};
export var Webstore = connect(mapStateToProps)(Radium(_Webstore));

